import React, { useState, useEffect } from 'react';

// COMPONENTS
import TableComponent from 'components/common/tableComponent';
import SearchBar from 'components/administration/searchBarComponent';

// SERVICES
import { getUserConnectionStats } from 'services/statService';

const Logs = () => {
    const [logs, setLogs] = useState([]);
    const [filteredLogs, setFilteredLogs] = useState([]);
    const [searchValue, setSearchValue] = useState('');

    const columns = [
        {
            key: 'USR_EMAILADDRESS',
            label: 'Utilisateur',
            type: 'profil',
        },
        {
            key: 'UCS_CONN_AT',
            label: 'Date',
            type: 'datetime',
        },
        {
            key: 'UCS_ROUTE',
            label: 'Endpoint',
            type: 'link',
            onClick: (value) => window.open(value, '_blank'),
        },
    ];

    useEffect(() => {
        const fetchData = async () => {
            const response = await getUserConnectionStats();
            // On mappe les logs pour le champ 'profil'
            const mappedLogs = response.data.map(log => ({
                ...log,
                USR_EMAILADDRESS: {
                    src: `https://bes-sso.altitudeinfra.fr/avatar/${log.USR_EMAILADDRESS}`,
                    alt: log.USR_EMAILADDRESS || 'Utilisateur',
                    username: log.USR_EMAILADDRESS || 'Inconnu',
                }
            }));
            setLogs(mappedLogs);
            setFilteredLogs(mappedLogs);
        };
        fetchData();
    }, []);

    useEffect(() => {
        if (searchValue) {
            const filtered = logs.filter(log => 
                log.USR_EMAILADDRESS.username.toLowerCase().includes(searchValue.toLowerCase()) ||
                log.UCS_ROUTE.toLowerCase().includes(searchValue.toLowerCase())
            );
            setFilteredLogs(filtered);
        } else {
            setFilteredLogs(logs);
        }
    }, [searchValue, logs]);

    return (
        <div className="h-full flex flex-col">
            <div className="mb-6">
                <SearchBar 
                    value={searchValue}
                    onChange={(e) => setSearchValue(e.target.value)}
                    placeholder="Rechercher par utilisateur ou endpoint..."
                />
            </div>
            <div className="flex-1 min-h-0">
                <TableComponent 
                    columns={columns} 
                    rows={filteredLogs}
                    enablePagination={true}
                    defaultPageSize={10}
                    pageSizeOptions={[5, 10, 20, 50, 100]}
                    emptyText="Aucun log trouvé" 
                />
            </div>
        </div>
    );
};

export default Logs; 